import { FriendApiFriendUpdateRequest } from '../../openapi/api'
import appApiClient from './appApiClient'
import useBaseMutation from './useBaseMutation'

export const useFriendUpdateMutation = () =>
  useBaseMutation({
    mutationFn: (req: FriendApiFriendUpdateRequest, config) =>
      appApiClient.friendApi.friendUpdate(req, config),
  })
